import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=1ae7ec0a&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ae7ec0a')) {
      api.createRecord('1ae7ec0a', component.options)
    } else {
      api.reload('1ae7ec0a', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=1ae7ec0a&", function () {
      api.rerender('1ae7ec0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2WmM40PbFsFJc/JS/comp/childrenage.vue"
export default component.exports